module.exports = __webpack_public_path__ + "img/1-1_07.2b872754.jpg";